import script from "./PaintingStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./PaintingStatus.vue?vue&type=script&setup=true&lang=js"

import "./PaintingStatus.vue?vue&type=style&index=0&id=dfb1127e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfb1127e"]])

export default __exports__